import { Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "../Layout/AuthLayout";
import HeaderLayout from "../Layout/HeaderLayout";
import { PrivateWrapper } from "../Router/PrivateRoute";
import RouteLinks from "../Router/RouteLinks";
import Authentication from "./Authentication/Authentication";
import NotFound from "./NotFound/NotFound";
import PlanningDetail from "./Planning/Components/PlanningDetail";
import PlanningMain from "./Planning/PlanningMain";
import ServiceItemDetail from "./ServiceItem/ServiceItemDetail";
import CreateTimeRegistration from "./TimeRegistration/CreateTimeRegistration";
import NewServiceOrder from "./ServiceOrder/NewServiceOrder";

const BaseApp = () => {



    return (
        <Routes>
            <Route path="/" element={<AuthLayout pageTitle="Deloof" title="Deloof" />}>
                <Route key={"redirect"} index element={<Navigate to={"/" + RouteLinks.login} />} />
                <Route path={RouteLinks.login} element={<Authentication />} />

                <Route path="*" element={<NotFound displayText="Pagina niet gevonden." />} />
            </Route>
            <Route path={RouteLinks.service} element={
                <PrivateWrapper roles={[]}>
                    <HeaderLayout pageTitle="Deloof" title="Deloof" />
                </PrivateWrapper>
            }>
                <Route key={"redirect"} index element={<Navigate to={RouteLinks.planning} />} />
                <Route path={`${RouteLinks.newServiceOrder}`} element={<NewServiceOrder />} />
                <Route path={`${RouteLinks.planning}/${RouteLinks.orderDetail}/${RouteLinks.timeRegistration}`} element={<CreateTimeRegistration />} />
                <Route path={`${RouteLinks.planning}/${RouteLinks.orderDetail}/${RouteLinks.itemDetail}`} element={<ServiceItemDetail />} />
                <Route path={RouteLinks.planning} element={<PlanningMain />} >
                    <Route path={RouteLinks.orderDetail} element={<PlanningDetail />} />
                </Route>

                <Route path="*" element={<NotFound displayText="Pagina niet gevonden." />} />
            </Route>
        </Routes>
    )


}

export default BaseApp;